/* eslint-disable */
export const EXTERNAL_GROUP_TYPE = 'external_provider';
export const OON_GROUP_TYPE = 'out_of_network';
export const FEE_SCHEDULE_PROGRAM_TOOLTIP = 'This program is part of a contracted agreement that allows the provider to be reimbursed for their services.';
export const SERVICE_AREA_TYPE_NATIONAL = 'national';
export const SERVICE_AREA_TYPE_STATE = 'state';
